import { call, put, takeLeading } from "redux-saga/effects";

import { ApiService } from "pwapi";

import {
  ASSESSMENT_REQUEST,
  ASSESSMENT_SUCCESS,
  ASSESSMENT_FAILURE,
} from "../actions/constants";

function* postAssessment(action: any): any {
  try {
    const result = yield call(ApiService.createMrmcAssessment, {
      requestBody: action.payload.assessment,
    });
    console.log(result);
    yield put({ type: ASSESSMENT_SUCCESS, payload: result });
    yield action.payload.navigate.push("/");
  } catch (e) {
    yield put({
      type: ASSESSMENT_FAILURE,
      error: true,
      payload: e,
    });
  }
}

export function* assessmentSaga() {
  yield takeLeading(ASSESSMENT_REQUEST, postAssessment);
}
